import * as React from "react";

export default () => {
  return <div>Amorteringsrelaterad information</div>;
};
